import {CallTrackingResponse} from "../../types";

export class Api {
    constructor(private url: string) {

    }

    initCallTracking(
        swaps: string[],
        date: string,
        sessionId?: string,
        landingPage?: string,
        referrer?: string,
        lastOverSwappedAt?: string|null,
    ): Promise<Response> {
        return fetch(this.url, {
            method: 'POST',
            body: JSON.stringify({
                sessionId,
                landingPage,
                referrer,
                date,
                swaps,
                lastOverSwappedAt,
            }),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        })
    }

    async reportExtraNumbers(numbers: string[]) {
        await fetch(this.url + "/monitorExtraNumbers", {
            method: 'POST',
            body: JSON.stringify({
                numbers,
            }),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        })
    }

    async reportConflictingScript() {
        await fetch(this.url + "/monitorConflicts", {
            method: 'POST',
            body: JSON.stringify({}),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        })
    }

    async reportSwapChanged() {
        await fetch(this.url + "/monitorSwapChanged", {
            method: 'POST',
            body: JSON.stringify({}),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        })
    }
}